export default class EntryIdsSnippetNotFoundError extends Error {}
